import React, { useState, useEffect } from 'react';

import Combobox from "react-widgets/Combobox";


import { Link, useNavigate } from 'react-router-dom';
import { BsArrowLeftShort, BsPower, BsArrowLeftRight } from 'react-icons/bs';


import "react-widgets/styles.css";


import './style.css';
import api from '../../services/api'
import AppBar from '../../components/AppBar';
import Button from '../../components/Button';



export default function Translate() {
  //Create states
  const [textToTranslate, setTextToTranslate] = useState('HOJE E DIA DE FEZTA');
  const [translation, setTranslatedText] = useState('');
  const [fromTongueCode, setFromTongueCode] = useState("pt");
  const [toTongueCode, setToTongueCode] = useState('kea');


    const tongue =[
      {id: "pt", language: "Português"},
      {id: "ben", language: "Bengali" },
      {id: "kea", language: "Kabuverdiano"},
      {id: "en", language: "Inglês"},
    ]

    const tongueMapCode= {
       "pt":"Português",
       "ben" : "Bengali",
       "kea": "Kabuverdiano",
       "en": "Inglês"
  }

  useEffect(() => {


  }, [fromTongueCode, toTongueCode]);

  async function handleTranslation(error) {
    //  error.preventDefault();
    translate();
  }

  const translate = async () => {
    console.log('trainsalte')
    console.log(toTongueCode)
    const response = await api.get(`https://nomade-api-management.azure-api.net/nllb/translate?from_code=${fromTongueCode}&to_code=${toTongueCode}&text=${textToTranslate}`, {
      params: "" //data
    })
    console.log('response', response.data)
    console.log('response', response.data.result)
    setTranslatedText(response.data.result)
  }


  return (

    <div className="translate-container">
      <AppBar />


      <div className="content">


        <div className='languages'>

          <Combobox
            placeholder='Escolha um idioma'
            defaultValue="Português"
            data={tongue}
            textField='language'
            value={tongueMapCode.fromTongueCode}
            onChange={fromTongueCode => setFromTongueCode(fromTongueCode.id)}
          />

          <button className='button' onClick={handleTranslation} type="button">
            <BsArrowLeftRight size={20} color="#1ABC9C" />
          </button>

          <Combobox
            placeholder='Escolha um idioma'

            defaultValue="Bengali"
            data={tongue}
            textField='language'
            value={tongueMapCode.toTongueCode}
            onChange={toTongueCode => setToTongueCode(toTongueCode.id)} />


        </div>

        <div className='traduction'>

          <textarea
            placeholder="Texto"
            value={textToTranslate}
            onChange={error => setTextToTranslate(error.target.value)}
          />

          <div className='divider'></div>

          <textarea
            placeholder="Tradução"
            value={translation}
            onChange={error => setTranslatedText(error.target.value)}
          />

        </div>
        <div className="button-container" >

          <center> <button onClick={handleTranslation} type="button" class="btn btn-success">Traduzir</button></center>

        </div>
      </div>
    </div>
  );
}




















